import { useEffect, useRef, useState } from "react";
import { Smartphone } from "lucide-react";

/* CivicOS boot splash — plays once when the phone powers on. Handset brand boot:
   logo, carrier, version, progress bar, boot log. ~2.4s then hands over. */

const BOOT_LOG = [
  "civicos kernel 4.2.1 — ok",
  "bornwood telecom sim — registered",
  "secure enclave — armed",
  "hub uplink — connected",
  "apps — mounted",
];

export default function PhoneBoot({ accent, onDone }) {
  const [pct, setPct] = useState(0);
  const done = useRef(false);

  useEffect(() => {
    const t = setInterval(() => {
      setPct((p) => {
        const n = p + 2 + Math.random() * 5;
        if (n >= 100 && !done.current) {
          done.current = true;
          clearInterval(t);
          setTimeout(onDone, 450);
          return 100;
        }
        return Math.min(n, 100);
      });
    }, 60);
    return () => clearInterval(t);
  }, [onDone]);

  const logCount = Math.min(BOOT_LOG.length, Math.floor(pct / 22));

  return (
    <div data-testid="phone-boot" className="absolute inset-0 z-40 bg-black flex flex-col items-center justify-center px-8"
      style={{ animation: "ncFadeIn 0.3s ease both" }}>
      <div className="w-16 h-16 rounded-3xl flex items-center justify-center mb-5"
        style={{ backgroundColor: `${accent}18`, border: `1px solid ${accent}55`, boxShadow: `0 0 44px ${accent}44` }}>
        <Smartphone className="w-8 h-8" style={{ color: accent }} />
      </div>
      <p className="font-sans font-bold text-2xl text-white tracking-[0.2em]">CIVIC·OS</p>
      <p className="font-mono text-[8px] uppercase tracking-[0.4em] text-white/40 mt-1">4.2 · bornwood telecom</p>
      <div className="w-40 h-[3px] rounded-full bg-white/10 mt-8 overflow-hidden">
        <div data-testid="phone-boot-progress" className="h-full rounded-full transition-all duration-100" style={{ width: `${pct}%`, backgroundColor: accent }} />
      </div>
      <div className="mt-6 h-20 font-mono text-[7px] text-white/30 space-y-1 text-center">
        {BOOT_LOG.slice(0, logCount).map((l) => <p key={l}>{l}</p>)}
      </div>
    </div>
  );
}
